import type { PackageType } from "@b2bportal/core-packages";

export const RBC_PACKAGES_QUERY_PARAM = {
  upSell: "up_sell",
} as const;

export type PackageSearchQueryParams = {
  origin: string;
  destination: string;
  fromDate: string;
  untilDate: string;
  adults?: number;
  children?: number[] | null;
  infantsOnLap?: number;
  infantsInSeat?: number;
  roomCount: number;
  packageType: PackageType;
  driverAge?: number;
  packageToken?: string;
  /** UI-only: when "true", hides search/breadcrumbs and skips flight selection in the packages funnel */
  upSell?: string;
};
